var Page = /** @class */ (function () {
    function Page() {
    }
    return Page;
}());
export { Page };
//# sourceMappingURL=page.js.map